(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

require('bootstrap/js/dist/tooltip');

require('../../../modules/modules');

var _utilities = require('./utilities');

var _objectFitImages = require('object-fit-images');

var _objectFitImages2 = _interopRequireDefault(_objectFitImages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import 'bootstrap/js/dist/alert'
// import 'bootstrap/js/dist/button'
// import 'bootstrap/js/dist/carousel'
// import 'bootstrap/js/dist/modal'
// import 'bootstrap/js/dist/popover'
// import 'bootstrap/js/dist/scrollspy'
jQuery(function ($) {
  $(document).ready(function () {
    outdatedBrowser({
      bgColor: '#f25648',
      color: '#ffffff',
      lowerThan: 'IE11',
      languagePath: '../node_modules/outdated-browser/outdatedbrowser/lang/en.html'
    });
    (0, _utilities.superscript)();
  });
  $(function () {
    (0, _objectFitImages2.default)();
  });

  var $hero = $('.m-rez-hero');
  var $intro = $('.m-standard-header');

  var firstSectionHeadline = $('section:not(.m-rez-hero):not(.m-standard-header)').first().find('h2').first().text();
  $('section:not(.m-rez-hero):not(.m-standard-header)').first().find('h2').first().replaceWith('<h1 class="text-center">' + firstSectionHeadline + '</h1>');
});

},{"../../../modules/modules":5,"./utilities":2,"bootstrap/js/dist/tooltip":3,"object-fit-images":4}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
==========================================================================
utility functions
==========================================================================
*/
function getCookie(name) {
  var value = '; ' + document.cookie;
  var parts = value.split('; ' + name + '=');
  if (parts.length == 2) return parts.pop().split(';').shift();
}

function setCookie(name, value, days) {
  var date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  var expires = '; expires=' + date.toGMTString();
  document.cookie = name + '=' + value + expires + ';path=/';
}

function getParam(p) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.search;

  var match = RegExp('[?&]' + p + '=([^&]*)').exec(url);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

function getParams() {
  var query = window.location.search;

  return query ? (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
    var _param$split = param.split('='),
        _param$split2 = _slicedToArray(_param$split, 2),
        key = _param$split2[0],
        value = _param$split2[1];

    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
    return params;
  }, {}) : false;
}

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function superscript() {
  jQuery(function ($) {
    $('p,h1,h2,h3,h4,h5,h6,li,a,span,td,th,i,b,u,em,strong,del,label,small').contents().filter(function () {
      return this.nodeType === 3;
    }).replaceWith(function () {
      return this.nodeValue.replace(/[®™️]/g, '<sup>$&</sup>');
    });
  });
}

function urlDecode(str) {
  return decodeURIComponent((str + '').replace(/\+/g, '%20'));
}

/*
==========================================================================
class utility
==========================================================================
*/

var RezberryClass = function () {
  _createClass(RezberryClass, [{
    key: 'addListeners',


    /*
    ==========================================================================
    listeners
    ==========================================================================
    */
    value: function addListeners() {
      for (var selector in this.listeners) {
        this.addListener(selector, this.listeners[selector]);
      }
    }
  }, {
    key: 'addListener',
    value: function addListener(selector, listener) {
      if (listener instanceof Array) {
        for (var item in listener) {
          if (!listener.hasOwnProperty(item)) continue;
          this.addListener(selector, listener[item]);
        }
      } else {
        this[selector].on(listener.ev, this[listener.func].bind(this));
      }
    }

    /*
    ==========================================================================
    selectors
    ==========================================================================
    */

  }, {
    key: 'addSelectors',
    value: function addSelectors() {
      for (var name in this.selectors) {
        this.addSelector(name, this.selectors[name]);
      }
    }
  }, {
    key: 'addSelector',
    value: function addSelector(name, selector) {
      this['$' + name] = this.$scope.find(selector);
    }

    /*
    ==========================================================================
    init
    ==========================================================================
    */

  }]);

  function RezberryClass(scope) {
    _classCallCheck(this, RezberryClass);

    this.$scope = jQuery(scope);
  }

  return RezberryClass;
}();

/*
==========================================================================
export
==========================================================================
*/


exports.getCookie = getCookie;
exports.setCookie = setCookie;
exports.getParam = getParam;
exports.getParams = getParams;
exports.debounce = debounce;
exports.superscript = superscript;
exports.urlDecode = urlDecode;
exports.RezberryClass = RezberryClass;

},{}],3:[function(require,module,exports){
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0): tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */
var Tooltip = function ($) {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */
  var NAME = 'tooltip';
  var VERSION = '4.0.0';
  var DATA_KEY = 'bs.tooltip';
  var EVENT_KEY = "." + DATA_KEY;
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 150;
  var CLASS_PREFIX = 'bs-tooltip';
  var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", 'g');
  var DefaultType = {
    animation: 'boolean',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string',
    delay: '(number|object)',
    html: 'boolean',
    selector: '(string|boolean)',
    placement: '(string|function)',
    offset: '(number|string)',
    container: '(string|element|boolean)',
    fallbackPlacement: '(string|array)',
    boundary: '(string|element)'
  };
  var AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    LEFT: 'left'
  };
  var Default = {
    animation: true,
    template: '<div class="tooltip" role="tooltip">' + '<div class="arrow"></div>' + '<div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    selector: false,
    placement: 'top',
    offset: 0,
    container: false,
    fallbackPlacement: 'flip',
    boundary: 'scrollParent'
  };
  var HoverState = {
    SHOW: 'show',
    OUT: 'out'
  };
  var Event = {
    HIDE: "hide" + EVENT_KEY,
    HIDDEN: "hidden" + EVENT_KEY,
    SHOW: "show" + EVENT_KEY,
    SHOWN: "shown" + EVENT_KEY,
    INSERTED: "inserted" + EVENT_KEY,
    CLICK: "click" + EVENT_KEY,
    FOCUSIN: "focusin" + EVENT_KEY,
    FOCUSOUT: "focusout" + EVENT_KEY,
    MOUSEENTER: "mouseenter" + EVENT_KEY,
    MOUSELEAVE: "mouseleave" + EVENT_KEY
  };
  var ClassName = {
    FADE: 'fade',
    SHOW: 'show'
  };
  var Selector = {
    TOOLTIP: '.tooltip',
    TOOLTIP_INNER: '.tooltip-inner',
    ARROW: '.arrow'
  };
  var Trigger = {
    HOVER: 'hover',
    FOCUS: 'focus',
    CLICK: 'click',
    MANUAL: 'manual'
    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };

  var Tooltip =
  /*#__PURE__*/
  function () {
    function Tooltip(element, config) {
      /**
       * Check for Popper dependency
       * Popper - https://popper.js.org
       */
      if (typeof Popper === 'undefined') {
        throw new TypeError('Bootstrap tooltips require Popper.js (https://popper.js.org)');
      } // private


      this._isEnabled = true;
      this._timeout = 0;
      this._hoverState = '';
      this._activeTrigger = {};
      this._popper = null; // Protected

      this.element = element;
      this.config = this._getConfig(config);
      this.tip = null;

      this._setListeners();
    } // Getters


    var _proto = Tooltip.prototype;

    // Public
    _proto.enable = function enable() {
      this._isEnabled = true;
    };

    _proto.disable = function disable() {
      this._isEnabled = false;
    };

    _proto.toggleEnabled = function toggleEnabled() {
      this._isEnabled = !this._isEnabled;
    };

    _proto.toggle = function toggle(event) {
      if (!this._isEnabled) {
        return;
      }

      if (event) {
        var dataKey = this.constructor.DATA_KEY;
        var context = $(event.currentTarget).data(dataKey);

        if (!context) {
          context = new this.constructor(event.currentTarget, this._getDelegateConfig());
          $(event.currentTarget).data(dataKey, context);
        }

        context._activeTrigger.click = !context._activeTrigger.click;

        if (context._isWithActiveTrigger()) {
          context._enter(null, context);
        } else {
          context._leave(null, context);
        }
      } else {
        if ($(this.getTipElement()).hasClass(ClassName.SHOW)) {
          this._leave(null, this);

          return;
        }

        this._enter(null, this);
      }
    };

    _proto.dispose = function dispose() {
      clearTimeout(this._timeout);
      $.removeData(this.element, this.constructor.DATA_KEY);
      $(this.element).off(this.constructor.EVENT_KEY);
      $(this.element).closest('.modal').off('hide.bs.modal');

      if (this.tip) {
        $(this.tip).remove();
      }

      this._isEnabled = null;
      this._timeout = null;
      this._hoverState = null;
      this._activeTrigger = null;

      if (this._popper !== null) {
        this._popper.destroy();
      }

      this._popper = null;
      this.element = null;
      this.config = null;
      this.tip = null;
    };

    _proto.show = function show() {
      var _this = this;

      if ($(this.element).css('display') === 'none') {
        throw new Error('Please use show on visible elements');
      }

      var showEvent = $.Event(this.constructor.Event.SHOW);

      if (this.isWithContent() && this._isEnabled) {
        $(this.element).trigger(showEvent);
        var isInTheDom = $.contains(this.element.ownerDocument.documentElement, this.element);

        if (showEvent.isDefaultPrevented() || !isInTheDom) {
          return;
        }

        var tip = this.getTipElement();
        var tipId = Util.getUID(this.constructor.NAME);
        tip.setAttribute('id', tipId);
        this.element.setAttribute('aria-describedby', tipId);
        this.setContent();

        if (this.config.animation) {
          $(tip).addClass(ClassName.FADE);
        }

        var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;

        var attachment = this._getAttachment(placement);

        this.addAttachmentClass(attachment);
        var container = this.config.container === false ? document.body : $(this.config.container);
        $(tip).data(this.constructor.DATA_KEY, this);

        if (!$.contains(this.element.ownerDocument.documentElement, this.tip)) {
          $(tip).appendTo(container);
        }

        $(this.element).trigger(this.constructor.Event.INSERTED);
        this._popper = new Popper(this.element, tip, {
          placement: attachment,
          modifiers: {
            offset: {
              offset: this.config.offset
            },
            flip: {
              behavior: this.config.fallbackPlacement
            },
            arrow: {
              element: Selector.ARROW
            },
            preventOverflow: {
              boundariesElement: this.config.boundary
            }
          },
          onCreate: function onCreate(data) {
            if (data.originalPlacement !== data.placement) {
              _this._handlePopperPlacementChange(data);
            }
          },
          onUpdate: function onUpdate(data) {
            _this._handlePopperPlacementChange(data);
          }
        });
        $(tip).addClass(ClassName.SHOW); // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html

        if ('ontouchstart' in document.documentElement) {
          $('body').children().on('mouseover', null, $.noop);
        }

        var complete = function complete() {
          if (_this.config.animation) {
            _this._fixTransition();
          }

          var prevHoverState = _this._hoverState;
          _this._hoverState = null;
          $(_this.element).trigger(_this.constructor.Event.SHOWN);

          if (prevHoverState === HoverState.OUT) {
            _this._leave(null, _this);
          }
        };

        if (Util.supportsTransitionEnd() && $(this.tip).hasClass(ClassName.FADE)) {
          $(this.tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(Tooltip._TRANSITION_DURATION);
        } else {
          complete();
        }
      }
    };

    _proto.hide = function hide(callback) {
      var _this2 = this;

      var tip = this.getTipElement();
      var hideEvent = $.Event(this.constructor.Event.HIDE);

      var complete = function complete() {
        if (_this2._hoverState !== HoverState.SHOW && tip.parentNode) {
          tip.parentNode.removeChild(tip);
        }

        _this2._cleanTipClass();

        _this2.element.removeAttribute('aria-describedby');

        $(_this2.element).trigger(_this2.constructor.Event.HIDDEN);

        if (_this2._popper !== null) {
          _this2._popper.destroy();
        }

        if (callback) {
          callback();
        }
      };

      $(this.element).trigger(hideEvent);

      if (hideEvent.isDefaultPrevented()) {
        return;
      }

      $(tip).removeClass(ClassName.SHOW); // If this is a touch-enabled device we remove the extra
      // empty mouseover listeners we added for iOS support

      if ('ontouchstart' in document.documentElement) {
        $('body').children().off('mouseover', null, $.noop);
      }

      this._activeTrigger[Trigger.CLICK] = false;
      this._activeTrigger[Trigger.FOCUS] = false;
      this._activeTrigger[Trigger.HOVER] = false;

      if (Util.supportsTransitionEnd() && $(this.tip).hasClass(ClassName.FADE)) {
        $(tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
      } else {
        complete();
      }

      this._hoverState = '';
    };

    _proto.update = function update() {
      if (this._popper !== null) {
        this._popper.scheduleUpdate();
      }
    }; // Protected


    _proto.isWithContent = function isWithContent() {
      return Boolean(this.getTitle());
    };

    _proto.addAttachmentClass = function addAttachmentClass(attachment) {
      $(this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
    };

    _proto.getTipElement = function getTipElement() {
      this.tip = this.tip || $(this.config.template)[0];
      return this.tip;
    };

    _proto.setContent = function setContent() {
      var $tip = $(this.getTipElement());
      this.setElementContent($tip.find(Selector.TOOLTIP_INNER), this.getTitle());
      $tip.removeClass(ClassName.FADE + " " + ClassName.SHOW);
    };

    _proto.setElementContent = function setElementContent($element, content) {
      var html = this.config.html;

      if (typeof content === 'object' && (content.nodeType || content.jquery)) {
        // Content is a DOM node or a jQuery
        if (html) {
          if (!$(content).parent().is($element)) {
            $element.empty().append(content);
          }
        } else {
          $element.text($(content).text());
        }
      } else {
        $element[html ? 'html' : 'text'](content);
      }
    };

    _proto.getTitle = function getTitle() {
      var title = this.element.getAttribute('data-original-title');

      if (!title) {
        title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
      }

      return title;
    }; // Private


    _proto._getAttachment = function _getAttachment(placement) {
      return AttachmentMap[placement.toUpperCase()];
    };

    _proto._setListeners = function _setListeners() {
      var _this3 = this;

      var triggers = this.config.trigger.split(' ');
      triggers.forEach(function (trigger) {
        if (trigger === 'click') {
          $(_this3.element).on(_this3.constructor.Event.CLICK, _this3.config.selector, function (event) {
            return _this3.toggle(event);
          });
        } else if (trigger !== Trigger.MANUAL) {
          var eventIn = trigger === Trigger.HOVER ? _this3.constructor.Event.MOUSEENTER : _this3.constructor.Event.FOCUSIN;
          var eventOut = trigger === Trigger.HOVER ? _this3.constructor.Event.MOUSELEAVE : _this3.constructor.Event.FOCUSOUT;
          $(_this3.element).on(eventIn, _this3.config.selector, function (event) {
            return _this3._enter(event);
          }).on(eventOut, _this3.config.selector, function (event) {
            return _this3._leave(event);
          });
        }

        $(_this3.element).closest('.modal').on('hide.bs.modal', function () {
          return _this3.hide();
        });
      });

      if (this.config.selector) {
        this.config = _extends({}, this.config, {
          trigger: 'manual',
          selector: ''
        });
      } else {
        this._fixTitle();
      }
    };

    _proto._fixTitle = function _fixTitle() {
      var titleType = typeof this.element.getAttribute('data-original-title');

      if (this.element.getAttribute('title') || titleType !== 'string') {
        this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
        this.element.setAttribute('title', '');
      }
    };

    _proto._enter = function _enter(event, context) {
      var dataKey = this.constructor.DATA_KEY;
      context = context || $(event.currentTarget).data(dataKey);

      if (!context) {
        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
        $(event.currentTarget).data(dataKey, context);
      }

      if (event) {
        context._activeTrigger[event.type === 'focusin' ? Trigger.FOCUS : Trigger.HOVER] = true;
      }

      if ($(context.getTipElement()).hasClass(ClassName.SHOW) || context._hoverState === HoverState.SHOW) {
        context._hoverState = HoverState.SHOW;
        return;
      }

      clearTimeout(context._timeout);
      context._hoverState = HoverState.SHOW;

      if (!context.config.delay || !context.config.delay.show) {
        context.show();
        return;
      }

      context._timeout = setTimeout(function () {
        if (context._hoverState === HoverState.SHOW) {
          context.show();
        }
      }, context.config.delay.show);
    };

    _proto._leave = function _leave(event, context) {
      var dataKey = this.constructor.DATA_KEY;
      context = context || $(event.currentTarget).data(dataKey);

      if (!context) {
        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
        $(event.currentTarget).data(dataKey, context);
      }

      if (event) {
        context._activeTrigger[event.type === 'focusout' ? Trigger.FOCUS : Trigger.HOVER] = false;
      }

      if (context._isWithActiveTrigger()) {
        return;
      }

      clearTimeout(context._timeout);
      context._hoverState = HoverState.OUT;

      if (!context.config.delay || !context.config.delay.hide) {
        context.hide();
        return;
      }

      context._timeout = setTimeout(function () {
        if (context._hoverState === HoverState.OUT) {
          context.hide();
        }
      }, context.config.delay.hide);
    };

    _proto._isWithActiveTrigger = function _isWithActiveTrigger() {
      for (var trigger in this._activeTrigger) {
        if (this._activeTrigger[trigger]) {
          return true;
        }
      }

      return false;
    };

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, this.constructor.Default, $(this.element).data(), config);

      if (typeof config.delay === 'number') {
        config.delay = {
          show: config.delay,
          hide: config.delay
        };
      }

      if (typeof config.title === 'number') {
        config.title = config.title.toString();
      }

      if (typeof config.content === 'number') {
        config.content = config.content.toString();
      }

      Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
      return config;
    };

    _proto._getDelegateConfig = function _getDelegateConfig() {
      var config = {};

      if (this.config) {
        for (var key in this.config) {
          if (this.constructor.Default[key] !== this.config[key]) {
            config[key] = this.config[key];
          }
        }
      }

      return config;
    };

    _proto._cleanTipClass = function _cleanTipClass() {
      var $tip = $(this.getTipElement());
      var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);

      if (tabClass !== null && tabClass.length > 0) {
        $tip.removeClass(tabClass.join(''));
      }
    };

    _proto._handlePopperPlacementChange = function _handlePopperPlacementChange(data) {
      this._cleanTipClass();

      this.addAttachmentClass(this._getAttachment(data.placement));
    };

    _proto._fixTransition = function _fixTransition() {
      var tip = this.getTipElement();
      var initConfigAnimation = this.config.animation;

      if (tip.getAttribute('x-placement') !== null) {
        return;
      }

      $(tip).removeClass(ClassName.FADE);
      this.config.animation = false;
      this.hide();
      this.show();
      this.config.animation = initConfigAnimation;
    }; // Static


    Tooltip._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        var _config = typeof config === 'object' && config;

        if (!data && /dispose|hide/.test(config)) {
          return;
        }

        if (!data) {
          data = new Tooltip(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(Tooltip, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default;
      }
    }, {
      key: "NAME",
      get: function get() {
        return NAME;
      }
    }, {
      key: "DATA_KEY",
      get: function get() {
        return DATA_KEY;
      }
    }, {
      key: "Event",
      get: function get() {
        return Event;
      }
    }, {
      key: "EVENT_KEY",
      get: function get() {
        return EVENT_KEY;
      }
    }, {
      key: "DefaultType",
      get: function get() {
        return DefaultType;
      }
    }]);

    return Tooltip;
  }();
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */


  $.fn[NAME] = Tooltip._jQueryInterface;
  $.fn[NAME].Constructor = Tooltip;

  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Tooltip._jQueryInterface;
  };

  return Tooltip;
}($, Popper);

},{}],4:[function(require,module,exports){
/*! npm.im/object-fit-images 3.2.4 */
'use strict';

var OFI = 'bfred-it:object-fit-images';
var propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
var testImg = typeof Image === 'undefined' ? {style: {'object-position': 1}} : new Image();
var supportsObjectFit = 'object-fit' in testImg.style;
var supportsObjectPosition = 'object-position' in testImg.style;
var supportsOFI = 'background-size' in testImg.style;
var supportsCurrentSrc = typeof testImg.currentSrc === 'string';
var nativeGetAttribute = testImg.getAttribute;
var nativeSetAttribute = testImg.setAttribute;
var autoModeEnabled = false;

function createPlaceholder(w, h) {
	return ("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E");
}

function polyfillCurrentSrc(el) {
	if (el.srcset && !supportsCurrentSrc && window.picturefill) {
		var pf = window.picturefill._;
		// parse srcset with picturefill where currentSrc isn't available
		if (!el[pf.ns] || !el[pf.ns].evaled) {
			// force synchronous srcset parsing
			pf.fillImg(el, {reselect: true});
		}

		if (!el[pf.ns].curSrc) {
			// force picturefill to parse srcset
			el[pf.ns].supported = false;
			pf.fillImg(el, {reselect: true});
		}

		// retrieve parsed currentSrc, if any
		el.currentSrc = el[pf.ns].curSrc || el.src;
	}
}

function getStyle(el) {
	var style = getComputedStyle(el).fontFamily;
	var parsed;
	var props = {};
	while ((parsed = propRegex.exec(style)) !== null) {
		props[parsed[1]] = parsed[2];
	}
	return props;
}

function setPlaceholder(img, width, height) {
	// Default: fill width, no height
	var placeholder = createPlaceholder(width || 1, height || 0);

	// Only set placeholder if it's different
	if (nativeGetAttribute.call(img, 'src') !== placeholder) {
		nativeSetAttribute.call(img, 'src', placeholder);
	}
}

function onImageReady(img, callback) {
	// naturalWidth is only available when the image headers are loaded,
	// this loop will poll it every 100ms.
	if (img.naturalWidth) {
		callback(img);
	} else {
		setTimeout(onImageReady, 100, img, callback);
	}
}

function fixOne(el) {
	var style = getStyle(el);
	var ofi = el[OFI];
	style['object-fit'] = style['object-fit'] || 'fill'; // default value

	// Avoid running where unnecessary, unless OFI had already done its deed
	if (!ofi.img) {
		// fill is the default behavior so no action is necessary
		if (style['object-fit'] === 'fill') {
			return;
		}

		// Where object-fit is supported and object-position isn't (Safari < 10)
		if (
			!ofi.skipTest && // unless user wants to apply regardless of browser support
			supportsObjectFit && // if browser already supports object-fit
			!style['object-position'] // unless object-position is used
		) {
			return;
		}
	}

	// keep a clone in memory while resetting the original to a blank
	if (!ofi.img) {
		ofi.img = new Image(el.width, el.height);
		ofi.img.srcset = nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
		ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;

		// preserve for any future cloneNode calls
		// https://github.com/bfred-it/object-fit-images/issues/53
		nativeSetAttribute.call(el, "data-ofi-src", el.src);
		if (el.srcset) {
			nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
		}

		setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);

		// remove srcset because it overrides src
		if (el.srcset) {
			el.srcset = '';
		}
		try {
			keepSrcUsable(el);
		} catch (err) {
			if (window.console) {
				console.warn('https://bit.ly/ofi-old-browser');
			}
		}
	}

	polyfillCurrentSrc(ofi.img);

	el.style.backgroundImage = "url(\"" + ((ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"')) + "\")";
	el.style.backgroundPosition = style['object-position'] || 'center';
	el.style.backgroundRepeat = 'no-repeat';
	el.style.backgroundOrigin = 'content-box';

	if (/scale-down/.test(style['object-fit'])) {
		onImageReady(ofi.img, function () {
			if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
				el.style.backgroundSize = 'contain';
			} else {
				el.style.backgroundSize = 'auto';
			}
		});
	} else {
		el.style.backgroundSize = style['object-fit'].replace('none', 'auto').replace('fill', '100% 100%');
	}

	onImageReady(ofi.img, function (img) {
		setPlaceholder(el, img.naturalWidth, img.naturalHeight);
	});
}

function keepSrcUsable(el) {
	var descriptors = {
		get: function get(prop) {
			return el[OFI].img[prop ? prop : 'src'];
		},
		set: function set(value, prop) {
			el[OFI].img[prop ? prop : 'src'] = value;
			nativeSetAttribute.call(el, ("data-ofi-" + prop), value); // preserve for any future cloneNode
			fixOne(el);
			return value;
		}
	};
	Object.defineProperty(el, 'src', descriptors);
	Object.defineProperty(el, 'currentSrc', {
		get: function () { return descriptors.get('currentSrc'); }
	});
	Object.defineProperty(el, 'srcset', {
		get: function () { return descriptors.get('srcset'); },
		set: function (ss) { return descriptors.set(ss, 'srcset'); }
	});
}

function hijackAttributes() {
	function getOfiImageMaybe(el, name) {
		return el[OFI] && el[OFI].img && (name === 'src' || name === 'srcset') ? el[OFI].img : el;
	}
	if (!supportsObjectPosition) {
		HTMLImageElement.prototype.getAttribute = function (name) {
			return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
		};

		HTMLImageElement.prototype.setAttribute = function (name, value) {
			return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
		};
	}
}

function fix(imgs, opts) {
	var startAutoMode = !autoModeEnabled && !imgs;
	opts = opts || {};
	imgs = imgs || 'img';

	if ((supportsObjectPosition && !opts.skipTest) || !supportsOFI) {
		return false;
	}

	// use imgs as a selector or just select all images
	if (imgs === 'img') {
		imgs = document.getElementsByTagName('img');
	} else if (typeof imgs === 'string') {
		imgs = document.querySelectorAll(imgs);
	} else if (!('length' in imgs)) {
		imgs = [imgs];
	}

	// apply fix to all
	for (var i = 0; i < imgs.length; i++) {
		imgs[i][OFI] = imgs[i][OFI] || {
			skipTest: opts.skipTest
		};
		fixOne(imgs[i]);
	}

	if (startAutoMode) {
		document.body.addEventListener('load', function (e) {
			if (e.target.tagName === 'IMG') {
				fix(e.target, {
					skipTest: opts.skipTest
				});
			}
		}, true);
		autoModeEnabled = true;
		imgs = 'img'; // reset to a generic selector for watchMQ
	}

	// if requested, watch media queries for object-fit change
	if (opts.watchMQ) {
		window.addEventListener('resize', fix.bind(null, imgs, {
			skipTest: opts.skipTest
		}));
	}
}

fix.supportsObjectFit = supportsObjectFit;
fix.supportsObjectPosition = supportsObjectPosition;

hijackAttributes();

module.exports = fix;

},{}],5:[function(require,module,exports){
'use strict';

require('./molecules/filter/filter');

require('./molecules/filters/filters');

require('./molecules/loading/loading');

require('./molecules/popup-gallery/popup-gallery');

require('./molecules/popup-iframe/popup-iframe');

require('./molecules/overlap/overlap');

require('./molecules/slick/slick');

require('./molecules/search-form/search-form');

require('./molecules/video/video');

require('./molecules/view-more/view-more');

require('./organisms/alert/alert');

require('./organisms/header/header');

require('./organisms/header-eyebrow/header-eyebrow');

require('./organisms/header-nav/header-nav');

require('./organisms/subnav/subnav');

require('./organisms/01-hero/01-hero');

require('./organisms/03-simple-content/03-simple-content');

require('./organisms/09-form/09-form');

},{"./molecules/filter/filter":6,"./molecules/filters/filters":7,"./molecules/loading/loading":8,"./molecules/overlap/overlap":9,"./molecules/popup-gallery/popup-gallery":10,"./molecules/popup-iframe/popup-iframe":11,"./molecules/search-form/search-form":12,"./molecules/slick/slick":13,"./molecules/video/video":14,"./molecules/view-more/view-more":15,"./organisms/01-hero/01-hero":16,"./organisms/03-simple-content/03-simple-content":17,"./organisms/09-form/09-form":18,"./organisms/alert/alert":19,"./organisms/header-eyebrow/header-eyebrow":20,"./organisms/header-nav/header-nav":21,"./organisms/header/header":22,"./organisms/subnav/subnav":23}],6:[function(require,module,exports){
'use strict';

var _utilities = require('../../../assets/src/js/utilities');

jQuery(function ($) {
  $(document).ready(function () {
    $(document).on('click', '.js-filter-value', function (e) {
      e.preventDefault();

      var $this = $(this),
          $filterWrapper = $this.parents('.js-filter-values').first(),
          endpoint = $filterWrapper.data('endpoint'),
          exclusive = $filterWrapper.data('exclusive'),
          $wrapper = $this.parents('[rez-app]');

      $filterWrapper.find('.js-filter-value').removeClass('is-active');

      if (exclusive) {
        var $otherWrappers = $wrapper.find('.js-filter-values').not($filterWrapper),
            $otherValues = $otherWrappers.find('.js-filter-value');
        $otherValues.removeClass('is-active');
        $otherValues.filter('[data-value="any"]').addClass('is-active');
      }

      $this.addClass('is-active');

      var $active = $wrapper.find('.js-filter-value.is-active').filter(':visible'),
          fields = [],
          operators = [],
          values = [],
          text = '';

      $active.each(function (index, item) {
        var $item = $(item),
            trimmed = $.trim($item.text());

        fields.push($item.data('field'));
        operators.push($item.data('operator') ? $item.data('operator') : 'equal');
        values.push($item.data('value'));

        $wrapper.find('.filter-indicator-' + (index + 1)).text(trimmed);

        if ($item.data('value') != 'any') {
          var newText = $item.data('label') + trimmed;
          text += !text.length ? newText : ', ' + newText;
        }
      });

      if (!text.length) text = 'Everything';
      $('.filters-desktop .filters-indicator').text(text);

      $('.filters-mobile .filters-group').collapse('hide');

      $('.loading').show();
      $.ajax({
        type: 'GET',
        url: endpoint,
        data: {
          fields: fields,
          operators: operators,
          values: values
        },
        success: function success(res) {
          $wrapper.find('.js-filters-stage').first().html(res);
          (0, _utilities.superscript)();
          $('.loading').hide();
        }
      });
    });

    var $active = $('.js-filter-value.is-active').filter(':visible');
    if ($active.length) {
      $active.each(function (index, item) {
        var $item = $(item);
        if ($item.data('value') != 'any') $item.trigger('click');
      });
    }
  });
});

},{"../../../assets/src/js/utilities":2}],7:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.filters-mobile .filters-group').on('show.bs.collapse', function () {
      $(this).parents('.filters-mobile').addClass('is-active');
    });
    $('.filters-mobile .filters-group').on('hidden.bs.collapse', function () {
      $(this).parents('.filters-mobile').removeClass('is-active');
    });
  });
});

},{}],8:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.loading:not(:first)').remove();
  });
});

},{}],9:[function(require,module,exports){
'use strict';

jQuery(function ($) {

  $(document).ready(function () {
    // invadedPadding()
  });

  $(window).on('resize, orientationChange', function () {
    // invadedPadding()
  });

  $('.rez-overlap').each(function () {
    var $section;

    if ($(this).is('section')) {
      $section = $(this);
    } else {
      $section = $(this).parents('section');
    }

    var $prevSection = $section.prev('section').not('.m-subnav');

    $prevSection.addClass('rez-space-invaded');

    $prevSection.each(function () {
      var $pbSection = $(this).filter(function () {
        return this.className.match(/\bpb/);
      }),
          pb;

      $pbSection.filter(function () {
        var classes = $(this).attr('class').split(" ");
        for (var i = 0; i < classes.length; i++) {
          if (classes[i].match('^pb')) {
            pb = classes[i];
          }
        }
      });

      $(this).removeClass(pb);
    });
  });

  function invadedPadding() {
    $('.rez-space-invaded').each(function () {
      var ih = $(this).height(),
          oh = $(this).outerHeight(),
          padding;

      console.log('outer:' + oh + '     inner:' + ih);

      if (ih == oh) {
        $(this).css('height', 'auto').css('height', oh + 100);
      } else {
        padding = (oh - ih) / 2;
        // console.log(pb)
        $(this).css('padding-bottom', padding + 100);
      }
    });
  }
});

},{}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popupGallery = undefined;

var _utilities = require('../../../assets/src/js/utilities');

$(document).ready(function () {
  return popupGallery();
});

function popupGallery() {
  $('.popup-gallery').each(function () {
    $(this).magnificPopup({
      delegate: '.popup-gallery-link:not(.slick-cloned)',
      type: 'image',
      closeBtnInside: false,
      fixedBgPos: true,
      fixedContentPos: true,
      mainClass: 'mfp-img-mobile',
      tLoading: 'Loading image #%curr%...',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1],
        arrowMarkup: '<img alt="%title%" class="m-popup-gallery-arrow mfp-arrow mfp-arrow-%dir%" src="/wp-content/themes/rezberrybud/assets/dist/images/icon-arrow-%dir%-dark.svg">',
        tCounter: '<span class="mfp-counter">%curr% of %total%</span>' // markup of counter
      },
      iframe: {
        tError: '<a href="%url%">The video #%curr%</a> could not be loaded.',
        titleSrc: function titleSrc(item) {
          return item.el.attr('title');
        },
        patterns: {
          youtube: {
            index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

            // id: 'v=', // String that splits URL in a two parts, second part should be %id%
            // Or null - full URL will be returned
            // Or a function that should return %id%, for example:
            // id: function(url) { return 'parsed id'; }
            id: function id(url) {
              return (0, _utilities.getParam)('v', url);
            },

            src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
          },
          vimeo: {
            index: 'vimeo.com/',
            id: '/',
            src: '//player.vimeo.com/video/%id%?autoplay=1'
          },
          wistia: {
            index: 'wistia.com/',
            id: '/medias/',
            src: '//fast.wistia.net/embed/iframe/%id%?videoFoam=true&autoplay=true'
          },
          gmaps: {
            index: '//maps.google.',
            src: '%id%&output=embed'
          }
        },
        markup: '<div class="mfp-iframe-scaler">' + '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' + '</div>' + '<div class="mfp-bottom-bar">' + '<div class="mfp-title"></div>' + '<h5 class="mfp-counter"></h5>' + '</div>'
      },
      image: {
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
        titleSrc: function titleSrc(item) {
          return item.el.attr('title');
        }
      }
    });
  });
}

exports.popupGallery = popupGallery;

},{"../../../assets/src/js/utilities":2}],11:[function(require,module,exports){
'use strict';

var _utilities = require('../../../assets/src/js/utilities');

jQuery(function ($) {
  $('.popup-iframe-link').magnificPopup({
    type: 'iframe',
    fixedBgPos: true,
    fixedContentPos: true,
    midClick: true,
    iframe: {
      patterns: {
        youtube: {
          index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

          // id: 'v=', // String that splits URL in a two parts, second part should be %id%
          // Or null - full URL will be returned
          // Or a function that should return %id%, for example:
          // id: function(url) { return 'parsed id'; }
          id: function id(url) {
            return (0, _utilities.getParam)('v', url);
          },

          src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
        },
        vimeo: {
          index: 'vimeo.com/',
          id: '/',
          src: '//player.vimeo.com/video/%id%?autoplay=1'
        },
        wistia: {
          index: 'wistia.com/',
          id: '/medias/',
          src: '//fast.wistia.net/embed/iframe/%id%?videoFoam=true&autoplay=true'
        },
        gmaps: {
          index: '//maps.google.',
          src: '%id%&output=embed'
        }
      }
    }
  });
});

},{"../../../assets/src/js/utilities":2}],12:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.m-search-form').submit(function (e) {
      if ($(this).find('[type="search"]').val() == '') {
        e.preventDefault();
      }
    });
  });
});

},{}],13:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
$(document).ready(function () {
  slickThis();
});
$(window).on('resize orientationchange', function () {
  slickThis();
});

function slickThis() {
  $('.slick-this:not(.slick-initialized)').each(function () {
    var adaptiveHeight = $(this).data('height'),
        arrows = $(this).data('arrows'),
        autoplay = $(this).data('autoplay'),
        dots = $(this).data('dots'),
        fade = $(this).data('fade'),
        slidesToScroll = $(this).data('scroll'),
        slidesToShow = $(this).data('show');
    //$arrows = $(this).siblings('.m-slider-arrows')

    $(this).slick({
      adaptiveHeight: adaptiveHeight,
      arrows: arrows,
      autoplay: autoplay,
      dots: dots,
      fade: fade,
      infinite: true,
      mobileFirst: true,
      //nextArrow: $arrows.find('.m-slider-arrows-arrow-right'),
      //prevArrow: $arrows.find('.m-slider-arrows-arrow-left'),
      rows: 0,
      slidesToScroll: slidesToScroll,
      slidesToShow: slidesToShow
    });
  });
}

exports.slickThis = slickThis;

},{}],14:[function(require,module,exports){
'use strict';

// taken from https://codepen.io/team/rcrooks1969/pen/opXWww

jQuery(function () {
  if (typeof videojs == 'undefined') return;

  // Create array for player IDs
  var players = [];

  // +++  Determine the available player IDs +++//
  for (var x = 0; x < Object.keys(videojs.players).length; x++) {
    // Assign the player name to setPlayer
    var setPlayer = Object.keys(videojs.players)[x];
    // Define the ready event for the player
    videojs.getPlayer(setPlayer).ready(function () {
      // Assign this player to a variable
      var myPlayer = this;
      // Assign and event listener for play event
      myPlayer.on('play', onPlay);
      // Push the player to the players array
      players.push(myPlayer);
    });
  }

  // +++ Handle all players' play event +++//
  function onPlay(e) {
    // Determine which player the event is coming from
    var id = e.target.id;
    // Loop through the array of players
    for (var i = 0; i < players.length; i++) {
      // Get the player(s) that did not trigger the play event
      if (players[i].id() != id) {
        // Pause the other player(s)
        videojs.getPlayer(players[i].id()).pause();
      }
    }
  }
});

},{}],15:[function(require,module,exports){
'use strict';

jQuery(function ($) {

  var ww = window.innerWidth;

  $(document).ready(function () {
    moduleShowToggle();
  });
  $(window).on('resize orientationchange', function () {
    moduleShowToggle();
  });

  function moduleShowToggle() {
    if (ww == window.innerWidth) return;
    $('.m-view-toggle').each(function () {
      var $this = $(this),
          $section = $this.parents('section'),
          cutoff = $this.data('cutoff'),
          numToShow = $this.data('num-to-show'),
          $more = $this.find('.view-more'),
          $less = $this.find('.view-less'),
          $toggleContainer = $section.find('.toggle-this-container');

      $section.find('.toggle-this:lt(' + cutoff + ')').show();
      var items = $section.find('.toggle-this').length,
          shown = cutoff;

      $more.click(function () {
        $(this).siblings('.view-less').show();
        var remaining = items - shown;
        // console.log($toggleContainer)
        if (remaining < numToShow) {
          shown = shown + remaining;
        } else {
          shown = shown + numToShow;
        }
        if (shown < items) {
          $toggleContainer.find('.toggle-this:lt(' + shown + ')').show(300);
        } else {
          $toggleContainer.find('.toggle-this:lt(' + items + ')').show(300);
          $(this).hide();
        }
      });

      if ($less.length) {
        less.click(function () {
          var hide = items - cutoff;
          $('html, body').animate({
            scrollTop: $toggleContainer.parent().offset().top
          }, 300);
          $toggleContainer.find('.toggle-this').not(':lt(' + cutoff + ')').hide(300);
          $(this).hide();
          $(this).siblings('.view-more').show();
          shown = cutoff;
        });
      }
    });

    ww = window.innerWidth;
  }
});

},{}],16:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  var slider = $('.m-rez-hero-slides');

  $(document).ready(function () {
    slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var currentVideo = $('[data-slick-index="' + currentSlide + '"]').find('video'),
          nextVideo = $('[data-slick-index="' + nextSlide + '"]').find('video');
      if (currentVideo.length) {
        currentVideo.get(0).pause();
      }
      if (nextVideo.length) {
        nextVideo.get(0).play();
      }
    });
    slider.on('init reInit', function () {
      var currentVideo = $('[data-slick-index="0"]').find('video');
      if (currentVideo.length) {
        currentVideo.get(0).play();
      }
    });
    slider.slick({
      infinite: true,
      rows: 0,
      arrows: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [{
        breakpoint: 767,
        settings: {
          // arrows: false,
          // dots: true
        }
      }]
    });
  });

  $(window).on('resize orientationchange', function () {
    slider.slick('resize');
  });
});

},{}],17:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $('.m-basic-content').each(function () {
    $(this).find('.m-basic-content-content').children().last().addClass('mb-0');
  });
});

},{}],18:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {

    $('.floating .ginput_container input, .floating .ginput_container .textarea, .floating .ginput_container .gf-select').each(function () {
      var placeholder = $(this).attr('placeholder');
      if ($(this).val() !== '' || placeholder != undefined) {
        $(this).parents('.ginput_container').siblings('label').addClass('focused');
      }
    });

    $('.floating .ginput_container input, .floating .ginput_container .textarea').on('focus keyup', function () {

      $(this).parents('.ginput_container').siblings('label').addClass('focused');
      if ($(this).val().length < 0) {
        $(this).parents('.ginput_container').siblings('label').addClass('focused');
      }
    });
    $('.floating .ginput_container input, .floating .ginput_container .textarea').on('blur', function () {
      if ($(this).val().length < 0) {
        $(this).parents('.ginput_container').siblings('label').removeClass('focused');
      }
    });

    $('.floating.gfield_contains_required .ginput_container input, .floating.gfield_contains_required .ginput_container .textarea').on('blur', function () {
      if ($(this).val() === '') {
        $(this).parents('.gfield').addClass('warning');
        $(this).parents('.ginput_container').siblings('label').removeClass('focused');
      } else {
        $(this).parents('.gfield').removeClass('warning');
      }
    });
  });

  $(window).on('load', function () {
    $('.gform_wrapper .ginput_container_checkbox').each(function () {
      $(this).parents('.gfield').addClass('gf-checkbox');
    });
    $('.gform_wrapper .ginput_container_radio').each(function () {
      $(this).parents('.gfield').addClass('gf-radio');
    });
    $('.gform_wrapper .ginput_container_fileupload').each(function () {
      $(this).parents('.gfield').addClass('gf-file');
    });
    $('.gform_wrapper .ginput_container_select').each(function () {
      $(this).parents('.gfield').addClass('gf-select');
      $(this).siblings('label').addClass('focused');
    });
    $('.gform_footer .gform_button').wrap('<div class="btn btn-primary"></div>');

    $('textarea').each(function () {
      var offset = this.offsetHeight - this.clientHeight;

      var resizeArea = function resizeArea(el) {
        $(el).css('height', '52px').css('height', el.scrollHeight + offset);
        $(el).parents('.ginput_container_textarea').css('height', el.scrollHeight + offset);
      };

      $(this).on('keyup input', function () {
        resizeArea(this);
      });
    });
  });
});

},{}],19:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    alertSize();

    if ($('.m-alert').length) {
      if (sessionStorage.getItem('alertState') != 'dismissed') {
        rezAlert();
      } else {
        $('.m-alert').hide();
        $('body').css('padding-bottom', 0);
      }
    }
  });

  $(window).on('resize orientationchange', function () {
    alertSize();
  });

  function rezAlert() {
    $('.m-alert').css('opacity', 1);

    $('.m-alert .close').on('click', function () {
      $('.m-alert').hide();
      $('body').css('padding-bottom', 0);
      sessionStorage.setItem('alertState', 'dismissed');
    });
  }

  function alertSize() {
    $('body').css('padding-bottom', 0);
    if ($('.m-alert').length) {
      var ah = $('.m-alert').height();
      $('body').css('padding-bottom', ah);
    }
  }
});

},{}],20:[function(require,module,exports){
'use strict';

var _headerNav = require('../header-nav/header-nav');

jQuery(function ($) {
  $(document).ready(function () {
    $('.m-header-eyebrow-search-toggle').click(function (e) {
      e.preventDefault();
      if (_headerNav.$searchForm.is(':visible')) {
        _headerNav.$overlay.hide();
        $(this).removeClass('is-active');
        _headerNav.$searchForm.velocity('finish').velocity('slideUp', {
          duration: 250,
          easing: 'easeInOut'
        });
        (0, _headerNav.scrollReset)();
      } else {
        (0, _headerNav.hideAllTheThings)(false);
        _headerNav.$overlay.show();
        $(this).addClass('is-active');
        (0, _headerNav.scrollOverride)();
        _headerNav.$searchForm.velocity('finish').velocity('slideDown', {
          duration: 250,
          easing: 'easeInOut',
          complete: function complete() {
            $(this).find('[type="search"]').focus();
          }
        });
      }
    });
  });
});

},{"../header-nav/header-nav":21}],21:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollReset = exports.scrollOverride = exports.$searchForm = exports.$overlay = exports.navBreakpoint = exports.hideAllTheThings = undefined;

var _utilities = require('../../../assets/src/js/utilities');

var $anchors2 = jQuery('.m-header-nav-list > li > a').not('.click-through'),
    $anchors = jQuery('.m-header-nav-item-inner > .m-header-nav-chevron-mobile'),
    $overlay = jQuery('.m-header-nav-overlay'),
    $searchForm = jQuery('.m-header-eyebrow-search'),
    $header = jQuery('.m-header'),
    navBreakpoint = 992,
    st = 0;

jQuery(function ($) {
  $(document).ready(function () {

    doNotCutMeOff();

    $('.m-header-nav-toggle').off('click');
    $('.m-header-nav-toggle').click((0, _utilities.debounce)(function (e) {
      e.preventDefault();
      if (!$(this).data('is-open')) {
        $('.m-header-nav-nav').velocity('finish').velocity('slideDown', {
          duration: 250,
          begin: function begin() {
            $header.css({
              'bottom': 0,
              'overflow-y': 'scroll'
            });
            scrollOverride();
          }
        });
        $(this).data('is-open', true);
      } else {
        hideAllTheThings(true);
        $('.m-header-nav-nav').velocity('finish').velocity('slideUp', {
          duration: 0,
          complete: function complete() {
            $header.css({
              'bottom': 'auto',
              'overflow-y': 'visible'
            });
            scrollReset();
          }
        });
        $(this).data('is-open', false);
      }
      $(this).toggleClass('is-active');
      $('.m-header-nav-nav').toggleClass('is-active');
    }, 500, true));

    $('.m-header-nav-item-close').click(function (e) {
      e.preventDefault();
      hideAllTheThings(true);
      scrollReset();
    });

    // separate click event needed to always prevent default
    $anchors.click(function (e) {
      e.preventDefault();
    });

    $anchors.click((0, _utilities.debounce)(function () {
      var $dropdown = $(this).parents('.m-header-nav-item-inner').next('.m-header-nav-item');
      var $anchorClass = 'level1';
      if ($(this).hasClass('m-header-sub-nav-chevron-mobile')) {
        $dropdown = $(this).parents('.m-header-sub-nav-items').find('.m-header-nav-item');
        $anchorClass = 'level2';
      }
      $anchors.removeClass('is-active');
      if ($('.m-header-nav-back').hasClass('level1')) {
        $('.m-header-nav-back').removeClass('level1').addClass('level2');
      } else {
        $('.m-header-nav-back').addClass('level1');
      }
      if (window.innerWidth >= navBreakpoint) {
        if ($dropdown.is(':visible')) {
          hideDropdown($dropdown, false, $.noop);
          $overlay.hide();
          scrollReset();
        } else {
          $(this).addClass('is-active');
          showDropdown($dropdown);
          $overlay.show();
        }
      } else {
        $(this).addClass('is-active');
        showDropdown($dropdown);
      }
    }, 500, true));

    $('.m-header-nav-back').click(function () {
      if (window.innerWidth <= navBreakpoint - 1) {
        hideAllTheThings(false);
      }
    });

    $overlay.click(function () {
      hideSearchForm();
      hideAllTheThings(false);
      scrollReset();
    });
  });

  function doNotCutMeOff() {
    // check for menus that would be cut off on the right side of screen
    if (window.innerWidth >= navBreakpoint - 1) {
      // if on desktop

      $('.m-header-nav-item.children').each(function () {
        $(this).show();
        var ddoffset = $(this).offset();
        var ddl = ddoffset.left;
        var ddwidth = $(this).width();
        var docw = $('.m-header-nav').width();
        var isEntirelyVisible = ddl + ddwidth <= docw;
        if (!isEntirelyVisible) {
          $(this).addClass('menu-edge');
        } else {
          $(this).removeClass('menu-edge');
          var gc = $(this).find('.grandchildren'); // even if child is not off screen, grandchildren might be
          if (gc.length > 0) {
            gc.show();
            var gcw = gc.width();
            var areGcVisible = ddl + ddwidth + gcw <= docw;
            if (!areGcVisible) {
              $(this).addClass('gc-edge');
            } else {
              $(this).removeClass('gc-edge');
            }
            gc.css('display', '');
          }
        }
        $(this).css('display', '');
      });
    }
  }

  // function showDesktopChild($child) {
  //   hideDropdown($('.m-header-nav-item.reveal'), true, function() {
  //     $('.children.reveal, .grandchildren.reveal').removeClass('reveal')
  //     $child.addClass('reveal')
  //     $('.m-header-nav-nav').addClass('has-open-dropdown');
  //     $child.velocity('finish').velocity('slideDown', {
  //       duration: 400,
  //       easing: 'easeInOut',
  //       begin: function() {
  //         st = $(window).scrollTop()
  //       },
  //       complete: function() {
  //         showDropdownChildren($child)
  //       }
  //     })
  //   })

  // }

  // function desktopNav() {
  //   if( window.innerWidth >= navBreakpoint - 1 ) { // if on desktop

  //     // show dropdown
  //     $('.m-header-nav-items.parent > .m-header-nav-item-inner > a').on('mouseenter', function() {
  //       var $dropdown = $(this).parent().siblings('.m-header-nav-item');
  //       $('.m-header-nav-item-inner .primary-nav-anchor-tracking').not($(this)).removeClass('is-active');
  //       if($dropdown.hasClass('children') || $dropdown.hasClass('grandchildren') ) {
  //         if( !$(this).hasClass('is-active') ) {
  //           $(this).addClass('is-active')
  //           showDesktopChild($dropdown)
  //         }
  //       }
  //       else {
  //         hideDropdown($('.m-header-nav-item.reveal'), true, $.noop);
  //       }
  //     })

  //     // show grandchildren
  //     $('.m-header-nav-item.children a').on('mouseenter', function() {
  //       var $dropdown = $(this).parent().siblings('.m-header-nav-item');
  //       if($dropdown.hasClass('grandchildren') ) {
  //         if (!$(this).hasClass('is-active') ) {
  //           $(this).addClass('is-active')
  //           $dropdown.addClass('reveal')
  //           $dropdown.velocity('finish').velocity('slideDown', {
  //             duration: 400,
  //             easing: 'easeInOut',
  //             begin: function() {
  //               st = $(window).scrollTop()
  //             },
  //             complete: function() {
  //               showDropdownChildren($dropdown)
  //             }
  //           })
  //         }
  //       }
  //     })

  //     // hide active dropdown when leaving menu from top nav items
  //     $('.m-header-nav-list').on('mouseleave', function() {
  //       hideDropdown($('.m-header-nav-item.reveal'), true, function() {
  //         $('a.is-active').removeClass('is-active')
  //       });
  //     });

  //     // hide active dropdown when leaving it
  //     $('.m-header-nav-item.children').on('mouseleave', function() {
  //       if(!$('.grandchildren').hasClass('reveal') ) {
  //         var $dropdown = $(this)
  //         $dropdown.removeClass('reveal')
  //         $('a.is-active').removeClass('is-active')
  //         $dropdown.velocity('finish').hide()
  //       }
  //     })

  //   }
  //   else { // mobile - turn off desktop functionality
  //     $('.m-header-nav-items.parent > .m-header-nav-item-inner > a').off('mouseenter');
  //     $('.m-header-nav-item.children a').off('mouseenter');
  //     $('.m-header-nav-list').off('mouseleave');
  //     $('.m-header-nav-item.children').off('mouseleave');
  //   }
  // };
  // $(document).ready(desktopNav);
  // $(window).resize(desktopNav);
});

var ww = window.innerWidth;
$(window).resize(function () {
  if (ww == window.innerWidth) return;
  var $dropdown = $('.m-header-nav-item');
  if (window.innerWidth <= navBreakpoint - 1) {
    $dropdown.each(function () {
      this.style.transform = 'translateX(100%)';
    });
    hideAllTheThings(true);
    $('.m-header-nav-back').hide();
    if ($('.m-header-nav-toggle').data('is-open') == true) {
      $header.css({
        'bottom': 0,
        'overflow-y': 'scroll'
      });
      scrollOverride();
    } else {
      $header.css({
        'bottom': 'auto',
        'overflow-y': 'visible'
      });
      scrollReset();
    }
  } else {
    $dropdown.each(function () {
      this.style.transform = 'none';
    });
    $('.m-header-nav-back').hide();
    $header.css({
      'bottom': 'auto',
      'overflow-y': 'visible'
    });
    if (!$dropdown.filter(':visible').length) {
      scrollReset();
    }
  }
  ww = window.innerWidth;
});

function showDropdown($dropdown) {
  jQuery(function ($) {
    $('.m-header-nav-nav').addClass('has-open-dropdown');
    hideSearchForm();
    if (window.innerWidth >= navBreakpoint) {
      if ($('.m-header-nav-item:visible').length) {
        hideDropdown($('.m-header-nav-item:visible'), false, $.noop);
        $dropdown.velocity('finish').show();
        showDropdownChildren($dropdown);
      } else {
        $dropdown.velocity('finish').velocity('slideDown', {
          duration: 400,
          easing: 'easeInOut',
          begin: function begin() {
            st = $(window).scrollTop();
          },
          complete: function complete() {
            showDropdownChildren($dropdown);
          }
        });
      }
    } else {
      $dropdown.velocity('finish').velocity({
        translateX: [0, '100%']
      }, {
        duration: 200,
        easing: 'easeInOut',
        display: 'block',
        complete: function complete() {
          showDropdownChildren($dropdown);
        }
      });
      var label = $dropdown.siblings('.m-header-nav-item-inner').find('.m-header-nav-item-label').text();
      $('.m-header-nav-back').text(label).velocity('finish').velocity({
        translateX: [0, '100%']
      }, {
        duration: 200,
        easing: 'easeInOut',
        display: 'block'
      });
    }
  });
}

function hideDropdown($dropdown, immediate, _callback) {
  jQuery(function ($) {
    $('.m-header-nav-nav').removeClass('has-open-dropdown');
    if (window.innerWidth >= navBreakpoint) {
      $dropdown.velocity('finish').hide();
    } else {
      $dropdown.velocity('finish').velocity({
        translateX: ['100%', 0]
      }, {
        duration: immediate ? 0 : 200,
        easing: 'easeInOut',
        display: 'none'
      });
      $('.m-header-nav-back').velocity('finish').velocity({
        translateX: ['100%', 0]
      }, {
        duration: immediate ? 0 : 200,
        easing: 'easeInOut',
        display: 'none'
      });
    }
    _callback();
  });
}

function hideAllTheThings(immediate) {
  var $dropdown = $('.m-header-nav-item:visible');
  // var $dropdown = $('.m-header-nav-list-child:visible')
  hideDropdown($dropdown, immediate, $.noop);
  $anchors.removeClass('is-active');
  $overlay.hide();
}

function hideSearchForm() {
  $('.m-header-eyebrow-search-toggle').removeClass('is-active');
  $searchForm.hide();
}

function showDropdownChildren($dropdown) {
  $dropdown.find('.m-header-nav-list-child').show();
  $dropdown.velocity('finish').velocity({
    translateX: ['0', 0]
  }, {
    duration: 200,
    easing: 'easeInOut',
    display: 'block'
  });
}

$.fn.extend({
  staggerFade: function staggerFade() {
    var display = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if ($(this).css('opacity') == 0) {
      var settings = {
        duration: 1000,
        stagger: 100,
        display: display,
        drag: true
      };
      $(this).velocity('transition.fadeIn', settings);
    }
  }
});

function scrollOverride() {
  st = $(window).scrollTop();
  $('html, body').css({
    'overflow-y': 'hidden',
    'height': '100%'
  });
}

function scrollReset() {
  $('html, body').css({
    'overflow-y': 'visible',
    'height': 'auto'
  });
  if (st > 0) $(window).scrollTop(st);
}

exports.hideAllTheThings = hideAllTheThings;
exports.navBreakpoint = navBreakpoint;
exports.$overlay = $overlay;
exports.$searchForm = $searchForm;
exports.scrollOverride = scrollOverride;
exports.scrollReset = scrollReset;

},{"../../../assets/src/js/utilities":2}],22:[function(require,module,exports){
'use strict';

var _headerNav = require('../header-nav/header-nav');

var _subnav = require('../subnav/subnav');

var ls = 0,
    $header = $('.m-header'),
    $eyebrow = $('.m-header-eyebrow'),
    $subnav = $('.js-subnav'),
    headerHeight,
    eyebrowHeight;

jQuery(function ($) {
  $(document).ready(function () {
    headerHeight = $header.outerHeight();
    if (window.innerWidth <= _headerNav.navBreakpoint - 1) {
      eyebrowHeight = 0;
    } else {
      eyebrowHeight = $eyebrow.outerHeight();
    }
    if ($(window).scrollTop() > 0) {
      scrollStuff();
    }
  });
  $(window).scroll(function () {
    (0, _subnav.toggleDockSubnav)();
    scrollStuff();
  });
  $(window).resize(function () {
    headerHeight = $header.outerHeight();
    if (window.innerWidth <= _headerNav.navBreakpoint - 1) {
      eyebrowHeight = 0;
    } else {
      eyebrowHeight = $eyebrow.outerHeight();
    }
  });
});

function scrollStuff() {

  jQuery(function ($) {
    var st = $(window).scrollTop();
    if (st >= headerHeight && st > ls && $header.data('is-visible')) {
      // hide on scroll down
      $header.velocity('finish').velocity({
        translateY: -headerHeight
      }, {
        duration: 400,
        easing: 'easeInOut',
        queue: false,
        progress: function progress() {
          return (0, _subnav.toggleDockSubnav)();
        }
      });
      $subnav.velocity('finish').velocity({
        translateY: 0
      }, {
        duration: 400,
        easing: 'easeInOut',
        queue: false
      });
      $eyebrow.data('is-visible', false);
      $header.data('is-visible', false);
    } else if (st < ls && !$header.data('is-visible')) {
      // show on scroll up
      $header.velocity('finish').velocity({
        translateY: -eyebrowHeight
      }, {
        duration: 400,
        easing: 'easeInOut',
        queue: false,
        progress: function progress() {
          return (0, _subnav.toggleDockSubnav)();
        }
      });
      $subnav.velocity('finish').velocity({
        translateY: headerHeight - eyebrowHeight
      }, {
        duration: 400,
        easing: 'easeInOut',
        queue: false
      });
      $eyebrow.data('is-visible', false);
      $header.data('is-visible', true);
    } else if (st <= eyebrowHeight) {
      // show eyebrow when top of page is hit
      $header.velocity('finish').velocity({
        translateY: 0
      }, {
        duration: 150,
        easing: 'easeInOut',
        queue: false
      });
      $subnav.velocity('finish').velocity({
        translateY: [headerHeight, $subnav.getTranslateY()]
      }, {
        duration: 150,
        easing: 'easeInOut',
        queue: false
      });
      $eyebrow.data('is-visible', true);
    }
    ls = st;
  });
}

},{"../header-nav/header-nav":21,"../subnav/subnav":23}],23:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleDockSubnav = undefined;

var _headerNav = require('../header-nav/header-nav');

var subnavWaypoint,
    $header = $('.m-header'),
    $eyebrow = $('.m-header-eyebrow'),
    $subnav = $('.js-subnav'),
    subnavIsDockable;

$(document).ready(function () {

  subnavIsDockable = $subnav.hasClass('is-dockable');

  addSubnavWrapper();

  $('.m-subnav-toggle').click(function () {
    if (window.innerWidth >= _headerNav.navBreakpoint) return;
    $(this).toggleClass('is-active');
    var $nav = $('.m-subnav-nav');
    if ($nav.is(':visible')) {
      $('.m-subnav-nav').velocity('slideUp', {
        duration: 250,
        easing: 'easeInOut'
      });
    } else {
      $('.m-subnav-nav').velocity('slideDown', {
        duration: 250,
        easing: 'easeInOut'
      });
    }
  });

  if (window.innerWidth <= _headerNav.navBreakpoint - 1) {
    var backlink = $.trim($('.m-subnav-back-title').text()),
        $active = $('.m-subnav-nav-list a.is-active').first(),
        active = $.trim($active.text());
    if ($active.length && active !== backlink) {
      $('.m-subnav-current').empty().append('<b> - ' + active + '</b>');
    }
  }

  $(window).resize(function () {
    return setWaypoint();
  });
});

$(window).on('load', function () {
  return setWaypoint();
});

function toggleDockSubnav() {
  if (!subnavIsDockable) return;

  if (typeof subnavWaypoint == 'undefined') setWaypoint();
  if (typeof subnavWaypoint == 'undefined') return;

  var st = $(window).scrollTop(),
      wp = subnavWaypoint;

  if ($eyebrow.data('is-visible') || window.innerWidth <= _headerNav.navBreakpoint - 1) {
    wp = subnavWaypoint - $header.outerHeight();
  } else if ($header.getTranslateY()) {
    wp = subnavWaypoint - $header.outerHeight() - $header.getTranslateY();
  }

  if (st > wp) {
    $subnav.removeClass('is-static').addClass('is-fixed');
  } else {
    $subnav.removeClass('is-fixed').addClass('is-static');
  }
}

function addSubnavWrapper() {
  if (!subnavIsDockable) return;
  var $wrap = $('.m-subnav-wrapper');
  if ($wrap.length) return;
  $wrap = $('<div class="m-subnav-wrapper" />').height($subnav.outerHeight());
  $subnav.wrap($wrap);
}

function setWaypoint() {
  var $wrap = $('.m-subnav-wrapper');
  if ($wrap.length && subnavIsDockable) subnavWaypoint = $wrap.offset().top;
}

$.fn.extend({
  getTranslateY: function getTranslateY() {
    if (!$(this).length || $(this).css('transform') == 'none') return 0;
    return parseFloat($(this).css('transform').split(',')[5].replace(')', ''));
  }
});

exports.toggleDockSubnav = toggleDockSubnav;

},{"../header-nav/header-nav":21}]},{},[1]);
